import { useColorScheme } from 'nativewind'
import { View } from 'react-native'
import { TableIcon as LucideTableIcon } from 'lucide-react-native'

const COLORS = {
  light: { icon: '#007AFF', background: 'rgba(0, 122, 255, 0.08)' },
  dark: { icon: '#0A84FF', background: 'rgba(10, 132, 255, 0.16)' },
}

export default function TableIcon() {
  const { colorScheme } = useColorScheme()
  const colors = colorScheme === 'dark' ? COLORS.dark : COLORS.light

  return (
    <View
      style={{
        width: 48,
        height: 48,
        borderRadius: 8,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.background,
      }}
    >
      <LucideTableIcon size={28} color={colors.icon} />
    </View>
  )
}
